import { render, staticRenderFns } from "./CockpitMatryoshkaInheritanceTreeSectionItem.vue?vue&type=template&id=71d57106&scoped=true"
import script from "./CockpitMatryoshkaInheritanceTreeSectionItem.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaInheritanceTreeSectionItem.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaInheritanceTreeSectionItem.vue?vue&type=style&index=0&id=71d57106&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d57106",
  null
  
)

export default component.exports